import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Seo } from "@/components/Seo";
import { errText, giftArt, giftBalance } from "@/lib/api";
import { cad } from "@/lib/site";

export default function GiftBalance() {
  const [code, setCode] = useState("");
  const [r, setR] = useState(null);
  const check = async (e) => { e.preventDefault(); try { setR(await giftBalance(code)); } catch (err) { setR(null); toast.error(errText(err)); } };
  return (
    <div className="mx-auto max-w-3xl px-5 py-20 sm:px-10" data-testid="gift-balance-page">
      <Seo title="Check gift card balance" description="Check the balance on your the suspects gift card." path="/gift-cards/balance" />
      <h1 className="display text-[clamp(3rem,8vw,6rem)]">Check your <span className="hl hl-sky hl-thick">balance</span></h1>
      <form onSubmit={check} className="mt-10 flex flex-wrap gap-3"><input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="SUS-XXXX-XXXX" className="field !mt-0 flex-1 font-mono" data-testid="gift-balance-code" /><button className="btn btn-ink" data-testid="gift-balance-submit">Check <ArrowRight size={16} /></button></form>
      {r && (
        <div className="mt-10 grid items-center gap-6 rounded-[24px] border-[1.5px] border-ink p-6 sm:grid-cols-2" data-testid="gift-balance-result">
          <img src={giftArt(r.design, r.initial)} alt="" className="rounded-[16px]" />
          <div><p className="font-mono font-bold">{r.code}</p><p className="display mt-2 text-6xl" data-testid="gift-balance-amount">{cad(r.balance)}</p><p className="text-sm text-ink/60">of {cad(r.initial)} · {r.status}</p></div>
        </div>
      )}
    </div>
  );
}
